// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientResponseModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Plan details
*/
export class EServicesOrchestratorServicePublicNewPathModelsTripleCheckPlanModel {
    /**
    * @description Gets or sets the bin.
    */
    'bin'?: string | null;
    /**
    * @description Gets or sets the card holder identifier.
    */
    'cardHolderId'?: string | null;
    /**
    * @description Gets or sets the insurance priority.
    */
    'coverageOrder'?: string | null;
    /**
    * @description Gets or sets the family unit number.
    */
    'familyUnitNumber'?: string | null;
    /**
    * @description Gets or sets Government Insured.
    */
    'governmentInsured'?: boolean;
    /**
    * @description Gets or sets the rx group identifier.
    */
    'groupId'?: string | null;
    /**
    * @description Gets or sets the name of the rx group.
    */
    'groupName'?: string | null;
    'patient'?: EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientResponseModel | null;
    /**
    * @description Gets or sets the name of the PBM payer.
    */
    'pbmName'?: string | null;
    /**
    * @description Gets or sets the PBM phone number.
    */
    'pbmPhone'?: string | null;
    /**
    * @description Gets or sets the Plan specific messages.
    */
    'pbmResponseMessage'?: string | null;
    /**
    * @description Gets or sets the PCN.
    */
    'pcn'?: string | null;
    /**
    * @description Gets or sets the Plan type.
    */
    'planType'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsTripleCheckPlanModel>> = [
        {
            "name":     "bin",
            "baseName": "bin",
            "type":     "string"
        },
        {
            "name":     "cardHolderId",
            "baseName": "cardHolderId",
            "type":     "string"
        },
        {
            "name":     "coverageOrder",
            "baseName": "coverageOrder",
            "type":     "string"
        },
        {
            "name":     "familyUnitNumber",
            "baseName": "familyUnitNumber",
            "type":     "string"
        },
        {
            "name":     "governmentInsured",
            "baseName": "governmentInsured",
            "type":     "boolean"
        },
        {
            "name":     "groupId",
            "baseName": "groupId",
            "type":     "string"
        },
        {
            "name":     "groupName",
            "baseName": "groupName",
            "type":     "string"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsTripleCheckPatientResponseModel"
        },
        {
            "name":     "pbmName",
            "baseName": "pbmName",
            "type":     "string"
        },
        {
            "name":     "pbmPhone",
            "baseName": "pbmPhone",
            "type":     "string"
        },
        {
            "name":     "pbmResponseMessage",
            "baseName": "pbmResponseMessage",
            "type":     "string"
        },
        {
            "name":     "pcn",
            "baseName": "pcn",
            "type":     "string"
        },
        {
            "name":     "planType",
            "baseName": "planType",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsTripleCheckPlanModel.attributeTypeMap;
    }
}
